import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import FixedPriceDifferenceModal from 'views/components/organisms/Cart/ProductListing/FixedPriceDifferenceModal'
import LifeStyleProductModal from 'views/components/organisms/Cart/ProductListing/LifeStyleProductModal'
import './PriceLabelTooltip.scss'
import type { ErxAndRxProductProps } from 'views/components/organisms/Cart/ProductListing/PriceLabelType'
import RxBonusModal from 'views/components/organisms/Cart/RxBonusModal'

export enum ModalType {
  FIXED_PRICE = 'fixedPrice',
  BONUS_ONLY = 'bonusOnly',
  LIFESTYLE = 'lifestyle',
}

interface PriceLabelTooltipProps {
  isRx?: boolean
  isERx?: boolean
  hasBonus?: boolean
  product: ErxAndRxProductProps
  modalType: ModalType
}

const modalComponentMap = {
  [ModalType.FIXED_PRICE]: FixedPriceDifferenceModal,
  [ModalType.LIFESTYLE]: LifeStyleProductModal,
  [ModalType.BONUS_ONLY]: RxBonusModal,
}

const PriceLabelTooltip = ({
  product,
  isRx,
  isERx,
  hasBonus = false,
  modalType,
}: PriceLabelTooltipProps) => {
  const ModalComponent = modalComponentMap[modalType]

  const modalBtnId = isERx
    ? product.hashedToken
    : product.cartInsertOrder.toString()
  return (
    <>
      <ModalShowButton
        component={ButtonTransparent}
        name={modalBtnId}
        modalId={modalBtnId}
        small
        inline
        onClick={null}
      >
        <IconCircleInfoOutline
          size="x-small"
          className="a-PriceLabelTooltip__icon"
        />
      </ModalShowButton>
      {ModalComponent && (
        <ModalComponent
          id={modalBtnId}
          isRx={isRx}
          isERx={isERx}
          hasBonus={hasBonus}
          open={false}
          productName={product?.productName}
          productCoPayment={product?.coPayment}
          productFixedPriceDifference={product?.fixedPriceDifference}
          productItemTotal={product?.itemTotal}
          productPrice={product.price}
        />
      )}
    </>
  )
}

export default PriceLabelTooltip
